module.exports = __webpack_public_path__ + "static/media/Sieg.996e6756.png";